// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"1a91c5d6","488":"d1b8b774","627":"d5358f20","653":"4a6a48b8","738":"b428087d","777":"6f294aa6","923":"93ebac32"}[chunkId] + ".chunk.js";
};